import { Bones } from '@simplywallst/components/Bones';

import { Grid } from '@simplywallst/ui-core';
import { FeedCardItemSkeleton } from './FeedCardItemSkeleton';

import { Wrapper, Header, StyledFeedCards, RoundBones } from './styled';

export const FeedCardSkeleton = () => (
  <Wrapper data-cy-id="dashboard-feed-skeleton">
    <Header gap="12px" templateColumns="min-content auto" alignItems="start">
      <div>
        <RoundBones minHeight="40px" minWidth="40px" />
      </div>
      <Grid rowGap="8px">
        <Grid templateColumns="repeat(2, 40px)" gap="8px">
          <Bones maxHeight="20px" maxWidth="40px" />
          <Bones maxHeight="40px" maxWidth="40px" />
        </Grid>
        <Bones maxHeight="40px" maxWidth="40px" />
        <Grid templateColumns="repeat(4, 40px)" gap="4px">
          <Bones maxHeight="10px" maxWidth="40px" />
          <Bones maxHeight="10px" maxWidth="40px" />
          <Bones maxHeight="10px" maxWidth="40px" />
          <Bones maxHeight="10px" maxWidth="40px" />
        </Grid>
      </Grid>
    </Header>

    <StyledFeedCards>
      <FeedCardItemSkeleton />
    </StyledFeedCards>
  </Wrapper>
);
